var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2344 0.703125L38.6719 9.14062H30.2344V0.703125Z",
    fill: "#CDD1D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6719 9.14062V44.2969H6.32812V0.703125H30.2344V9.14062H38.6719Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73438 6.32812V40.0781C7.73438 40.824 8.03069 41.5394 8.55814 42.0669C9.08558 42.5943 9.80095 42.8906 10.5469 42.8906H34.4531C35.199 42.8906 35.9144 42.5943 36.4419 42.0669C36.9693 41.5394 37.2656 40.824 37.2656 40.0781V38.5854C7.73438 36.7657 7.73438 6.32812 7.73438 6.32812Z",
    fill: "#E2E2E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6719 9.14062H30.9375V10.5469H38.6719V9.14062Z",
    fill: "#E2E2E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0156 2.8125H0.703125V14.0625H26.0156V2.8125Z",
    fill: "#2B8AE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6094 14.0625H6.32812V16.1719H24.6094V14.0625Z",
    fill: "#E2E2E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5469 20.3906V38.6719H31.6406V40.7812H8.4375V20.3906H10.5469Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 18.9844H16.1719V23.9062H28.125V18.9844Z",
    fill: "#2B8AE6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 33.75H16.1719V38.6719H28.125V33.75Z",
    fill: "#2B8AE6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 23.9062H16.1719V33.75H28.125V23.9062Z",
    fill: "#2B8AE6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 18.9844H28.125V38.6719H33.75V18.9844Z",
    fill: "#1668B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1719 18.9844H10.5469V38.6719H16.1719V18.9844Z",
    fill: "#1668B8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 23.2031H16.1719V24.6094H28.125V23.2031Z",
    fill: "#1668B8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 33.0469H16.1719V34.4531H28.125V33.0469Z",
    fill: "#1668B8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6094 28.8281L20.3906 31.6406V26.0156L24.6094 28.8281Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3438 21.0938H29.5312V23.9062H32.3438V21.0938Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3438 25.3125H29.5312V28.125H32.3438V25.3125Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3438 29.5312H29.5312V32.3438H32.3438V29.5312Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3438 33.75H29.5312V36.5625H32.3438V33.75Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7656 21.0938H11.9531V23.9062H14.7656V21.0938Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7656 25.3125H11.9531V28.125H14.7656V25.3125Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7656 29.5312H11.9531V32.3438H14.7656V29.5312Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7656 33.75H11.9531V36.5625H14.7656V33.75Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2359 11.7984L9.82969 5.47031C9.79273 5.315 9.70476 5.17656 9.57984 5.07713C9.45492 4.97771 9.30027 4.92304 9.14062 4.92188H7.73438C7.57473 4.92304 7.42008 4.97771 7.29516 5.07713C7.17024 5.17656 7.08227 5.315 7.04531 5.47031L5.63906 11.7984C5.63089 11.8496 5.62619 11.9013 5.625 11.9531H7.04531L7.51641 9.84375H9.35859L9.82969 11.9531H11.25C11.2488 11.9013 11.2441 11.8496 11.2359 11.7984ZM7.83281 8.4375L8.29688 6.32812H8.57812L9.04219 8.4375H7.83281Z",
    fill: "#F2F2F2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 4.92188H18.2812V11.9531H19.6875V4.92188Z",
    fill: "#F2F2F2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2031 10.5469H13.9219L12.6731 4.92188H11.25C11.2501 4.97316 11.2555 5.02429 11.2662 5.07445L12.6724 11.4026C12.7072 11.5588 12.7942 11.6986 12.9191 11.7987C13.044 11.8988 13.1993 11.9533 13.3594 11.9531H14.7656C14.9257 11.9533 15.081 11.8988 15.2059 11.7987C15.3308 11.6986 15.4178 11.5588 15.4526 11.4026L16.8588 5.07445C16.8695 5.02429 16.8749 4.97316 16.875 4.92188H15.4519L14.2031 10.5469Z",
    fill: "#F2F2F2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4112 11.9531H9.8297L9.3586 9.84375H7.51642L7.35962 10.5469H8.65548L9.12657 12.6562H10.5469C10.5457 12.6044 10.541 12.5527 10.5328 12.5016L10.4112 11.9531Z",
    fill: "#1668B8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04214 8.4375L8.57808 6.32812H8.29683L8.00854 7.63875L8.18433 8.4375H9.04214Z",
    fill: "#1668B8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63906 11.7949L7.01016 5.625C6.85463 5.63058 6.70519 5.68684 6.5846 5.78521C6.46401 5.88359 6.37889 6.01868 6.34219 6.16992L4.93594 12.498C4.92777 12.5492 4.92307 12.6009 4.92188 12.6527H6.34219L6.49898 11.9496H5.625C5.62619 11.8978 5.63089 11.8461 5.63906 11.7949Z",
    fill: "#1668B8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2812 5.625H17.5781V12.6562H18.9844V11.9531H18.2812V5.625Z",
    fill: "#1668B8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 11.9531C13.1993 11.9533 13.044 11.8988 12.9191 11.7987C12.7942 11.6986 12.7072 11.5588 12.6724 11.4026L11.3906 5.625H10.5469C10.547 5.67628 10.5524 5.72742 10.563 5.77758L11.9693 12.1057C12.004 12.262 12.091 12.4017 12.2159 12.5018C12.3409 12.6019 12.4962 12.6564 12.6562 12.6562H14.0625C14.2226 12.6564 14.3779 12.6019 14.5028 12.5018C14.6277 12.4017 14.7147 12.262 14.7495 12.1057L14.7839 11.9531C14.7776 11.9531 14.772 11.9531 14.7656 11.9531H13.3594Z",
    fill: "#1668B8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2018 10.5469L15.2959 5.625H14.7488L13.7891 9.94359L13.9234 10.5469H14.2018Z",
    fill: "#1668B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvi);
export default __webpack_public_path__ + "static/media/avi.a83727cf20e51848ef247a6d77ed4388.svg";
export { ForwardRef as ReactComponent };